import React from 'react';
type SectionHeadingProps = {
  eyebrow: string;
  title: string;
  description?: string;
  align?: 'center' | 'left';
};
export function SectionHeading({
  eyebrow,
  title,
  description,
  align = 'center'
}: SectionHeadingProps) {
  const isCenter = align === 'center';
  return <div className={isCenter ? 'mx-auto max-w-2xl text-center' : 'max-w-2xl'} data-id="element-156" data-mp="3jzx3jxnxq4oc">
      <span className="text-xs font-bold uppercase tracking-[0.18em] text-brand-ink/40" data-id="element-157" data-mp="3k2043bmprg7b">
        {eyebrow}
      </span>
      <h2 className="mt-3 text-3xl font-extrabold tracking-tight sm:text-4xl" data-id="element-158" data-mp="gj6sh4dhx1fs">{title}</h2>
      {description && <p className="mt-4 text-base leading-relaxed text-brand-ink/60 sm:text-lg" data-id="element-159" data-mp="1vc05p3egz38">{description}</p>}
    </div>;
}